<!-- ConnectionStatus.vue - Indicador de estado de conectividad -->
<template>
  <v-chip
    :color="connectionColor"
    :prepend-icon="connectionIcon"
    size="small"
    variant="flat"
    class="connection-status"
  >
    <span class="connection-text">{{ connectionText }}</span>
    <v-tooltip activator="parent" location="bottom">
      {{ connectionTooltip }}
    </v-tooltip>
  </v-chip>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import websocketService from '@/services/websocket.service'

const connectionStatus = ref({
  isConnected: false,
  reconnectAttempts: 0,
  socketState: 'CLOSED'
})

// Actualizar estado cada segundo
let statusInterval = null

const connectionColor = computed(() => {
  if (connectionStatus.value.isConnected) return 'success'
  if (connectionStatus.value.reconnectAttempts > 0) return 'warning'
  return 'error'
})

const connectionIcon = computed(() => {
  if (connectionStatus.value.isConnected) return 'mdi-wifi'
  if (connectionStatus.value.reconnectAttempts > 0) return 'mdi-wifi-sync'
  return 'mdi-wifi-off'
})

const connectionText = computed(() => {
  if (connectionStatus.value.isConnected) return 'Conectado'
  if (connectionStatus.value.reconnectAttempts > 0) return 'Reconectando...'
  return 'Desconectado'
})

const connectionTooltip = computed(() => {
  const status = connectionStatus.value
  
  if (status.isConnected) {
    return 'WebSocket conectado - Actualizaciones en tiempo real activas'
  }
  
  if (status.reconnectAttempts > 0) {
    return `Reintentando conexión (${status.reconnectAttempts}/5)`
  }
  
  return `WebSocket desconectado - Estado: ${status.socketState}`
})

const updateStatus = () => {
  const ws = websocketService.getConnectionStatus()
  connectionStatus.value = {
    isConnected: ws.connected,
    reconnectAttempts: ws.queuedMessages,
    socketState: ws.connecting ? 'CONNECTING' : ws.connected ? 'OPEN' : 'CLOSED'
  }
}

onMounted(() => {
  updateStatus()
  
  // Actualizar estado cada segundo
  statusInterval = setInterval(updateStatus, 1000)
})

onUnmounted(() => {
  if (statusInterval) {
    clearInterval(statusInterval)
  }
})
</script>

<style scoped>
.connection-status {
  transition: all 0.3s ease;
  cursor: help;
}

.connection-text {
  font-size: 0.75rem;
  font-weight: 500;
}

.connection-status:hover {
  transform: scale(1.05);
}
</style>
